import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-outer',
  templateUrl: './outer.component.html',
  styleUrls: ['./outer.component.scss']
})
export class OuterComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
